import { render, staticRenderFns } from "./faq-question-reponse.vue?vue&type=template&id=3edfb3b9&scoped=true"
import script from "./faq-question-reponse.vue?vue&type=script&lang=js"
export * from "./faq-question-reponse.vue?vue&type=script&lang=js"
import style0 from "./faq-question-reponse.vue?vue&type=style&index=0&id=3edfb3b9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3edfb3b9",
  null
  
)

export default component.exports